import '@/scss/mindarc-astro.scss'

import Vue from 'vue'

// Global components
import ExampleComponent from '@/js/components/example-component.vue'
import VueHeader from '@/js/components/vue-header.js'
import ProductDetail from '@/js/templates/product-detail'
import QuantityField from '@/js/components/quantity-field.vue'
import VueAccordion from '@/js/components/vue-accordion.vue'
import VueCollapsible from '@/js/components/vue-collapsible.vue'
import KeenSlider from '@/js/components/keen-slider.vue'
import ProductGridItem from '@/js/templates/product-grid-item.js'
import PopupVto from '@/js/components/popup-vto.vue'
import FreeGift from '@/js/components/free-gift'
import FreeGiftCard from '@/js/components/free-gift-card'

Vue.component('ExampleComponent', ExampleComponent)
Vue.component('QuantityField', QuantityField)
Vue.component('PopupVto', PopupVto)

const initVueInstance = element => {
  return new Vue({
    el: element,

    delimiters: ['${', '}'],

    components: {
      ProductDetail,
      VueHeader,
      VueAccordion,
      VueCollapsible,
      KeenSlider,
      ProductGridItem,
      FreeGift,
      FreeGiftCard
    },

    data () {
      return {
        giftSettings: window.__giftSettings || {}
      }
    }
  })
}

const initVue = () => document.querySelectorAll('[vue-init]').forEach(element => {
  initVueInstance(element)
})

initVue()

// Fix for theme editor preview
document.addEventListener('shopify:section:load', (event) => {
  // Vue HTML tags disappear so it can't reinitialise, causing the header to break
  if (event.target.id.includes('megamenu')) return
  initVue()
})
